import { LoadingPage } from "../../../../shared/components/LoadingPage";
import { Table } from "antd";
import useGetProdutosEstoque from "../../hooks/useGetEstoque";
import { colunas } from "../../util/EstoqueCol";

interface ProdutoEstoqueProps {
  produtoId: number
}

function EstoqueProduto({produtoId} : ProdutoEstoqueProps) {
  const { data: EstoqueProduto, isLoading } = useGetProdutosEstoque(produtoId);
  const EstoqueProdutoData = EstoqueProduto?.map((estoque: any, index: number) => ({
    key: index,
    ...estoque,
    ContatoNome: estoque.ContatoNome +' '+ estoque.ContatoSobrenome,
  }));

  return (
    <div className="flex flex-row w-[50rem]">
      {isLoading ? <div className="h-[20rem] w-[50rem] flex items-center justify-center"><LoadingPage /></div> :
        <div className="w-full">
          <Table
            pagination={{defaultPageSize: 10, showSizeChanger: false}}
            dataSource={EstoqueProdutoData}
            columns={colunas}
          />
        </div>
      }
    </div>
  );
}

export default EstoqueProduto
